import { forwardRef, type ReactNode, type Ref } from 'react'

import type { CSSProperties } from 'styled-components'

import { Container } from './Container'
import { Header } from './Header'
import { Title } from './Title'

type Props = {
	children: ReactNode
	title?: ReactNode
	aside?: ReactNode
	style?: CSSProperties
	className?: string
}

export const Card = forwardRef(({ children, title, aside, style, className }: Props, ref?: Ref<HTMLDivElement>) => (
	<Container ref={ref} style={style} className={className} hasHeader={Boolean(title || aside)}>
		{(title || aside) && (
			<Header>
				<Title>{title}</Title>
				{aside}
			</Header>
		)}
		{children}
	</Container>
))
